import { getEventRegistrationCount } from '@/services/webApi';
import { useQuery } from '@tanstack/react-query';

export default function useEventRegistrationCountQuery({
  id,
  enabled = true
}: {
  id: string;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: ['eventRegistrationCount', id],
    retry: false,
    enabled: !!id && enabled,
    queryFn: () => getEventRegistrationCount(id),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5
  });
}
